import {
  IconScreenShare,
  IconShoppingBag,
  IconShoppingBagX,
} from '@tabler/icons-react';
import { EnrollmentStatus } from '@zorro/clients';
import { Button } from '@zorro/design-system/v2/Button';
import { Group, Icon } from '@zorro/web/design-system';
import {
  createImpersonationSession,
  getImpersonationRoute,
  useMonolithQuery,
} from '@zorro/web/ui-utils';

const impersonationActiveStatuses = [
  EnrollmentStatus.ELECTION_ACTIVE,
  EnrollmentStatus.ELECTION_ACTIVE_HAS_NOT_STARTED,
  EnrollmentStatus.ELECTION_ACTIVE_STARTED,
];

type Props = {
  onWaiveCoverageClick: () => void;
  onManualElectionClick: () => void;
  withActiveImpersonationButton: boolean;
  onboardingPeriodId: string;
  employeeId: string;
  enrollmentStatus: EnrollmentStatus;
};

export const EmployeePagePlansActionButtons = ({
  onWaiveCoverageClick,
  onManualElectionClick,
  withActiveImpersonationButton,
  onboardingPeriodId,
  employeeId,
  enrollmentStatus,
}: Props) => {
  const { data: onboardingPeriods = [], isFetching } = useMonolithQuery({
    method: 'onboardingPeriodsControllerFindMany',
    params: [employeeId],
  });

  const onboardingPeriod = onboardingPeriods.find(
    ({ id }) => id === onboardingPeriodId
  );

  const handleImpersonationClick = () => {
    if (withActiveImpersonationButton && onboardingPeriod) {
      createImpersonationSession(
        employeeId,
        getImpersonationRoute(onboardingPeriod.type)
      );
    }
  };

  if (!onboardingPeriod || isFetching) {
    return null;
  }

  const isManualSubmissionActive = !onboardingPeriods.some(
    ({ id, isActive }) => id !== onboardingPeriodId && isActive
  );
  const isImpersonationModeActive =
    impersonationActiveStatuses.includes(enrollmentStatus);

  return (
    <Group wrap="nowrap">
      <Button
        leftSection={<Icon icon={IconScreenShare} />}
        disabled={!withActiveImpersonationButton || !isImpersonationModeActive}
        onClick={handleImpersonationClick}
        variant="secondary"
        size="lg"
        w="100%"
      >
        Start live joint session
      </Button>
      <Button
        leftSection={<Icon icon={IconShoppingBagX} />}
        onClick={onWaiveCoverageClick}
        variant="secondary"
        size="lg"
        w="100%"
      >
        Waive this coverage
      </Button>
      <Button
        leftSection={<Icon icon={IconShoppingBag} />}
        onClick={onManualElectionClick}
        disabled={!isManualSubmissionActive}
        variant="secondary"
        size="lg"
        w="100%"
      >
        Start manual election
      </Button>
    </Group>
  );
};
